import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import {select, Store} from '@ngrx/store';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import {loadProjekteStart} from '../../store/actions/getAllProjekte.actions';
import {ProjektItem} from '../../projekt.model';
import {Observable} from 'rxjs';
import { ProjektState } from '../../store/reducer/projektverwaltung.reducer';
import {MitarbeiterFormdialogComponent} from '../../../Mitarbeiterverwaltung/components/mitarbeiter-form-dialog/mitarbeiter-formdialog.component';
import {ProjektFormdialogComponent} from '../projekt-form-dialog/projekt-formdialog.component';
import {MitarbeiterItem} from '../../../Mitarbeiterverwaltung/mitarbeiter.model';
import {deleteMitarbeiterStart} from '../../../Mitarbeiterverwaltung/store/actions/mitarbeiter-del.actions';
import {deleteProjektStart} from '../../store/actions/projekt-del.actions';
import {NodeItem} from '../../node.model';
import {addProjektstufeStart} from '../../store/actions/projektstufe-add.actions';
import {loadNodesStart} from '../../store/actions/getAllNodes.actions';
import {archiveProjektStart} from '../../store/actions/projekt-archive.actions';
import {ProjektStufeFormdialogComponent} from '../projektstufe-form-dialog/projektstufe-formdialog.component';
import {dearchiveProjektStart} from "../../store/actions/projekt-dearchive.actions";
import {Router} from "@angular/router";
import {pasteProjektStart} from "../../store/actions/projekt-paste.actions";
import {HttpClient} from '@angular/common/http';
import {Security} from '../../../../security';


@Component({
    selector: 'app-projektverwaltung-page',
    templateUrl: './projektverwaltung-page.component.html',
    styleUrls: ['./projektverwaltung-page.component.scss'],
})



export class ProjektverwaltungPageComponent implements OnInit {


  public $nodes;
  public $copyNodes;

  /**
   * Constructor of Addresses page
   *
   * @param store - The store service
   * @param dialog - The dialog service
   */
  constructor(
    private _router: Router ,
    private store: Store<{ projektverwaltung: ProjektState }>,
    public dialog: MatDialog,
    public http: HttpClient,
    public security: Security
  )
  {

    this.$nodes = store.pipe(select((state) => state.projektverwaltung.nodes.items));
    this.$copyNodes = store.pipe(select((state) => state.projektverwaltung.copyNodes.items));
  }
    public showAdd: Observable<boolean>;
    public functionMenuEnabled: boolean;

  public addProjekt(): void{
    const dialogRef = this.dialog.open(ProjektFormdialogComponent, {
      data: {
        title: 'pages.projektverwaltung.addProjekt.title',
        submitButtonLabel: 'pages.projektverwaltung.addProjekt.submitButtonLabel',
        cancelButtonLabel: 'pages.projektverwaltung.addProjekt.cancelButtonLabel',
        start: '',
        ende: '',
        verrechnen: '1',
      },
    });
    dialogRef.afterClosed().subscribe();
  }

  public editProjekt(projekt: NodeItem): void{
    const dialogRef = this.dialog.open(ProjektFormdialogComponent, {
      data: {
        title: 'pages.projektverwaltung.editProjekt.title',
        submitButtonLabel: 'pages.projektverwaltung.editProjekt.submitButtonLabel',
        cancelButtonLabel: 'pages.projektverwaltung.editProjekt.cancelButtonLabel',
        id: projekt.id,
        ort: projekt.ort,
        plz: projekt.plz,
        str1: projekt.str1,
        str2: projekt.str2,
        nummer: projekt.nummer,
        name: projekt.name,
        start: projekt.start,
        ende: projekt.ende,
        beschreibung: projekt.beschreibung,
        auftraggeber: projekt.auftraggeber,
        abteilung: projekt.abteilung,
        mitarbeiter: projekt.mitarbeiter,
        verrechnen: projekt.verrechnen
      },
    });
    dialogRef.afterClosed().subscribe();
  }

  public editProjektstufe(projekt: NodeItem): void{
    const dialogRef = this.dialog.open(ProjektFormdialogComponent, {
      data: {
        title: 'pages.projektverwaltung.editProjektstufe.title',
        submitButtonLabel: 'pages.projektverwaltung.editProjekt.submitButtonLabel',
        cancelButtonLabel: 'pages.projektverwaltung.editProjekt.cancelButtonLabel',
        id: projekt.id,
        ort: projekt.ort,
        plz: projekt.plz,
        str1: projekt.str1,
        str2: projekt.str2,
        nummer: projekt.nummer,
        name: projekt.name,
        start: projekt.start,
        ende: projekt.ende,
        level: projekt.level,
        beschreibung: projekt.beschreibung,
        auftraggeber: projekt.auftraggeber,
        abteilung: projekt.abteilung,
        mitarbeiter: projekt.mitarbeiter,
        verrechnen: projekt.verrechnen
      },
    });
    dialogRef.afterClosed().subscribe();
  }

  public deleteProjekt(projekt: NodeItem): void{
    this.store.dispatch(deleteProjektStart({item: projekt}));
  }
  public archiveProjekt(projekt: NodeItem): void{
    this.store.dispatch(archiveProjektStart({item: projekt}));
  }
  public dearchiveProjekt(projekt: NodeItem): void{
    this.store.dispatch(dearchiveProjektStart({item: projekt}));
  }

  public addProjektstufe(projekt: NodeItem): void{

    const dialogRef = this.dialog.open(ProjektFormdialogComponent, {
      data: {
        title: 'pages.projektverwaltung.addProjektstufe.title',
        submitButtonLabel: 'pages.projektverwaltung.addProjekt.submitButtonLabel',
        cancelButtonLabel: 'pages.projektverwaltung.addProjekt.cancelButtonLabel',
        level: parseInt(projekt.level, 10) + 1,
        prjprj: projekt.id,
        start: '',
        ende: '',
        verrechnen: '1',
      },
    });
    dialogRef.afterClosed().subscribe();
  }
    /**
     * Executed when the component is initialized
     */
    public ngOnInit(): void {
      this.showAdd = this.security.checkIfAllowed('2001');
      this.functionMenuEnabled = true;
      this.store.dispatch(loadNodesStart({archiv: 0}));
    }
}
